import { render } from "./Model.vue?vue&type=template&id=6aac744a&ts=true"
import script from "./Model.vue?vue&type=script&lang=ts"
export * from "./Model.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/javiermartin/OneDrive_Sigeen/Sistena/Server_Mio/sistena-admin-gui-main_rev1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__